import { useState } from "react";
import { FileSpreadsheet, FileText } from "lucide-react";
import { CSVLink } from "react-csv";

import DistributionSummaryTotal from "../distribution-summary-total/distribution-summary-total.component";
import Pagination from "../pagination/pagination.component";
import { formatData, generatePDF } from "./utils";

const DistributionSummary = ({ distribution, fromDate, toDate }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = distribution.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => {
        if (pageNumber === 0) {
            setCurrentPage(() => currentPage - 1);
        } else if (pageNumber > distribution.length) {
            setCurrentPage(currentPage + 1);
        } else {
            setCurrentPage(pageNumber);
        }
    };

    return (
        <div className="overflow-x-auto">
            <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4">
                Distribution Details
            </h3>
            <div className="space-y-6">
                {distribution.length > 0
                    ? currentItems.map((item, idx) => (
                        <div key={idx} className="border border-gray-100 rounded-xl p-4">
                            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
                                <h4 className="font-semibold text-gray-900">
                                    {item.company
                                        ? `Company: ${item.company}`
                                        : item.agentReportingCode
                                            ? `Agent: ${item.agentReportingCode}`
                                            : null}
                                </h4>
                                <div className="flex items-center gap-2">
                                    <CSVLink
                                        data={formatData(item)}
                                        filename={
                                            item.company !== undefined
                                                ? `${item.company}.csv`
                                                : `${item.agentReportingCode}.csv`
                                        }
                                        className="h-8 px-3 border border-gray-200 text-gray-600 rounded-lg text-sm font-medium hover:bg-gray-50 hover:text-gray-900 transition-colors inline-flex items-center gap-1.5"
                                        title="Download CSV"
                                    >
                                        <FileSpreadsheet className="w-4 h-4" />
                                        <span>CSV</span>
                                    </CSVLink>
                                    <button
                                        onClick={() => generatePDF(item, fromDate, toDate)}
                                        className="h-8 px-3 border border-gray-200 text-gray-600 rounded-lg text-sm font-medium hover:bg-gray-50 hover:text-gray-900 transition-colors inline-flex items-center gap-1.5"
                                        title="Download PDF"
                                    >
                                        <FileText className="w-4 h-4" />
                                        <span>PDF</span>
                                    </button>
                                </div>
                            </div>
                            <DistributionSummaryTotal
                                spendingAccountsTotal={item.spendingAccountsTotal}
                                enrollmentFeeTotal={item.enrollmentFeeTotal}
                                teladocTotal={item.teladocTotal}
                                corehealthTotal={item.corehealthTotal}
                                total={item.total}
                            />
                        </div>
                    ))
                    : null}
                {distribution.length > itemsPerPage && (
                    <nav aria-label="Distribution navigation" className="mt-4">
                        <Pagination
                            itemsPerPage={itemsPerPage}
                            totalItems={distribution.length}
                            paginate={paginate}
                            currentPage={currentPage}
                        />
                    </nav>
                )}
            </div>
        </div>
    );
};

export default DistributionSummary;
